import React from 'react';
import {useTranslation} from 'react-i18next';
import {CheckboxButton} from '../../../components/buttons/checkbox-button/checkbox-button';

export function AlertsFilterWarningsComponent(props: any) {
    const {t} = useTranslation();
    // Function que comproba si esta o no seleccionat el filtre
    const activeFilter = (id: number) => {
        let filterOK = false;
        if (props.filters.length > 0) {
            props.filters.forEach((filter: any) => {
                if (filter.id == id) {
                    filterOK = true;
                }
            });
        } else {
            filterOK = true;
        }
        return filterOK;
    };
    return (<div className="alerts-filters-container">
        <div className="alert-filter-section">{t('translation:misc_alert_filter_type_section')}</div>
        <div className="container-section">
            {props.filterOptions.map((filters: any) =>
                <div key={filters.id}>
                    <div>
                        <CheckboxButton
                            isChecked={activeFilter(filters.id)}
                            label={t(filters.label)}
                            value={filters.value}
                            changeActiveFilter={props.changeActiveFilter}
                            filterOption={filters}
                            icon={filters.icon}
                        />
                    </div>
                </div>,
            )}
        </div>
    </div>
    );
}
